<template>
    <div class="app-inner">
            <div class="public-btn-div public-btn-small flex align-cen" style="padding-left:0">
                <div class="public-add" @click="addSolution" v-if="!authType">
                    新增案例
                </div>
                </div>
         <div class="p-tit-c">
             <div class="businessList-filter">
                <div class="businessList-filter-list flex align-cen">
                     <div class="fl-le flex align-cen">
                    <div class="label">典型案例名称：</div>
                    <div class="el-select1">
                        <el-input placeholder="请输入典型案例名称" v-model="search" clearable> </el-input>
                    </div>
                    </div>
                     <div class="fl-rt flex align-cen">
                    <div class="label">典型案例ID：</div>
                    <div class="el-select1">
                        <el-input placeholder="请输入典型案例ID" v-model="search1" clearable> </el-input>
                    </div>
                    </div>
                </div>
               <div class="businessList-filter-list flex align-cen">
                    <div class="label">案例分类：</div>
                     <el-select
                            v-model="value"
                            clearable
                            placeholder="请选择" 
                            @change="classSelect"
                        >
                            <el-option
                            v-for="(item,index) in options"
                            :key="index"
                            :label="item.name"
                            :value="item.id"
                            >
                            </el-option>
                        </el-select>
                 </div>
             <div class="businessList-filter-list flex align-cen"  v-if="!selectType">
                    <div class="label">启用状态：</div>
                      <div
                            style="color: red; padding-right: 20px; cursor: pointer"
                            @click="allradio('')"
                            >
                            不限
                            </div>
                        <el-radio v-model="radio" label="1" @change="classSelect">启用</el-radio>
                        <el-radio v-model="radio" label="0" @change="classSelect">禁用</el-radio>
                 </div>
                   <div class="businessList-filter-list flex align-cen">
                    <div class="label">应用官网分类：</div>
                    <div
                      style="color: red; padding-right: 20px; cursor: pointer"
                      @click="allradio(1)"
                    >
                      不限
                    </div>
                    <el-radio v-model="radio1" label="1" @change="classSelect">和隆优化官网</el-radio>
                    <el-radio v-model="radio1" label="2" @change="classSelect">和隆软件官网</el-radio>
                  </div>
          <div class="businessList-filter-list flex align-cen">
                     <div class="label">创建时间：</div>
                      <el-date-picker
                            v-model="value1"
                            type="datetimerange"
                            range-separator="至"
                            start-placeholder="开始时间"
                            end-placeholder="结束时间"
                            format="yyyy-MM-dd HH:mm:ss"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            :picker-options="pickerOptions2"
                            @change="classSelect"
                            >
                            </el-date-picker>
                  </div>
                             <div class="businessList-filter-list flex align-cen public-btn-small">
                            <div class="public-btn-small-primary" @click="classSelect">
                            搜索
                            </div>
                            <div class="public-btn-small-text" @click="reset">
                            重置筛选条件
                            </div>
      </div>
             </div>
         </div>
            <div class="businessList-container">
            <div class="businessList-container-table">
                           <el-table
          ref="multipleTable"
          :data="list"
          tooltip-effect="dark"
          style="width: 100%"
          border
          id='mytable'
           :row-key="getRowKeyOfTarget"
          @selection-change="handleSelectionChange"
          @select='onTableSelect'
          :header-cell-style="{background:'#f7f8fa',color:'#333'}"
        >
         <el-table-column type="selection" width="55" reserve-selection>  </el-table-column>
         <el-table-column prop="sort" label="排序" align="center">
          </el-table-column>
         <el-table-column prop="id" label="案例ID" align="center">
          </el-table-column>
            <el-table-column label="应用官网分类" align="center" prop="id">
          <template slot-scope="scope">
            <span>
              {{$util.offType(scope.row.officialType)}}
            </span>
          </template>
         </el-table-column>
         <el-table-column  label="封面图片" align="center" width="200">
            <template slot-scope="scope">
                <img :src="scope.row.pic" alt="" style="height:70px;width:200px">
            </template>
          </el-table-column>
           <el-table-column prop="name" label="案例名称" align="center">
          </el-table-column>
           <el-table-column prop="createTime" label="创建时间" align="center" width="200">
          </el-table-column>
           <el-table-column  label="创建人" align="center" prop="createBy">
          </el-table-column>
             <el-table-column  label="启用状态" align="center" v-if="!authType">
            <template slot-scope="scope">
                <div class="buStatus" @click.stop="changeStatus(scope)">
                <el-switch
                  v-model="scope.row.state == 0 ? false : true"
                  disabled
                >
                </el-switch>
              </div>
            </template>
          </el-table-column>
           <el-table-column
            fixed="right"
            label="操作"
            align="center"
            width="250"    
           v-if="!authType"
            >
              <template slot-scope="scope" >
                <el-button type="text" size="small" @click="preview(scope.row)">预览</el-button>
                  <el-button type="text" size="small" @click="openPoster(scope.row)">查看链接海报</el-button>
                   <el-button type="text" size="small"  @click.stop="addSolution(scope.row)">编辑</el-button>
                    <el-button type="text" size="small"  style="color:red" @click.stop="deletSolution(scope.row)">删除</el-button>
            </template>
            </el-table-column>
                  <el-table-column
            fixed="right"
            label="操作"
            align="center"
            width="100"
            v-if="authType == 1"
            >
            <template slot-scope="scope">
               <el-button type="text" size="small" style="color:red" @click="emitchose(scope.row)">选择</el-button>
            </template>
               </el-table-column>
     </el-table>
      <paginaTion :total="totalCount" @sendStatus="emitFun"></paginaTion>
            </div>
            </div>
   <el-dialog
  title="查看链接海报"
  :visible.sync="centerDialogVisible1"
  width="440px"
  :append-to-body="true"
  center>
     <div class="dia-can">
                 <vue-canvas-poster :widthPixels="370" :painting="painting" @success="success" @fail="fail"></vue-canvas-poster>
            </div>
            <div class="dia-btn" @click="$util.downloadFile(dowloadImgName,posterImg)">保存</div>
  <div class="linkdiv">
     典型案例链接：{{link}}
    <span @click.stop="copy(link)" style="color:#409eff;cursor: pointer;">复制</span>
  </div>
</el-dialog>
    </div>
</template>
<script>
import { caseClassify,caseList,getCase,editCase} from "@/api/index/index"  //查询解决分类、典型案例列表、删除典型案例、修改状态
import paginaTion from "@/components/paginaTion/index.vue"; //分页组件
export default {
    name:'solution',
     components:{
      paginaTion
    },
    props: {
    selectType: [String, Boolean], //是否为组件调用 
    authType:[String, Number],
    bussID:[String, Number],
    importName:[String, Number],
    isAppId:[Boolean]
    },
    data() {
        return {
          selsctarr:[],
          radio1:'',
          dowloadImgName:'典型案例海报',
          centerDialogVisible1:false,
            list:[
            ],
            search:'',
            search1:'',
            value:'',
            radio:'',
            value1:'',
            start_time:'',
            end_time:'',
            options:[],
              currentPage: 1, //初始页
            PageSize: 10, //每页的数据
            totalCount:0,
            pickerOptions2: {
          shortcuts: [{
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }]
             },
            link:'',
            catchStatus:false,
            multipleSelection:[],
        posterImg:'',
          painting: {
                    width: '371px',
                    height: '460px',
                    background: '#f4f5f7',
                    borderRadius:'20px',
                    views: [
                        {
                            type: 'image',
                            url: '',
                            css: {
                                top: '0px',
                                left: '0px',
                                borderRadius:'20px 20px 0 0',
                                width: '371px',
                                height: '130px'
                            },
                        },
                         {
                            type:'image',
                            url: require('../../../assets/images/HeroopSys.png'),
                            css: {
                                top:'150px',
                                 width: "130px",
                                 height:"44px",
                                 textAlign: "center",
                                 left:"120.5px"
                            }
                        },
                        {
                            type:'text',
                            text: '',
                            css: {
                                top:'210px',
                                 width: "100%",
                            textAlign: "center",
                            fontSize: "14px",
                            maxLines: "2",
                            lineHeight: "20px"
                            }
                        },
                         {
                        type: 'qrcode',
                        content: '',
                        css: {
                            top: '250px',
                            left: '110px',
                            color: '#000',
                            width: '150px',
                            height: '150px'
                        }
                        },
                          {
                            type:'text',
                            text: '技术支持：北京和隆软件有限公司',
                            css: {
                                bottom:'20px',
                                left:'0px',
                                 width: "100%",
                                textAlign: "center",
                                fontSize: "12px",
                                maxLines: "1",
                                color: '#333',
                            }
                        }
                        // ....
                    ],
           },
        }
    },
   activated(){
  this.gethisInfo()
},
    created() {
      if(this.authType) this.gethisInfo()
       this.$nextTick(() =>{
           this.getcaseClassify()
        })
    },
    methods: {
             // 新增修改调用方法
        editfun(val){
            this.selsctarr = val        
        },
        // 新增修改调用清空方法
        remove(){
           this.multipleSelection = []
        },
       // 表格选择
         handleSelectionChange(val) {
          this.multipleSelection = val;
           this.$emit('sendStatus', this.multipleSelection,false)
         },
              // 手动选择
    onTableSelect(rows, row){
         this.catchStatus = rows.length && rows.indexOf(row) !== -1
    },
         getRowKeyOfTarget(row) {
            return row.id
            },
      // 组件使用选择
      emitchose(data){
         this.$emit('sendStatus', data)
      },
         // 复制链接
          copy(link){
             let _self = this
      this.$copyText(link).then(
        function(e) {
            _self.$message.success('复制成功')
        },
        function(e) {
         _self.$message.error('复制失败')
        }
      );
    },
    // 海报绘制成功钩子
            success(src) {
             this.posterImg = src;
            },
              // 海报绘制失败钩子
            fail(err) {
                console.log('fail', err)
            },
         // 手动修改海报views
        handleChangeImg(data){
          // console.log(data)
            this.painting.views[0].url = data.pic
             this.painting.views[2].text = data.name
             this.painting.views[3].content = data.contentType == 1 ? this.$config.prUrl + '#/webenterprise/enCaseDetail?id='+ data.id : data.content
        },
      // 打开链接海报
            openPoster(data){
                if(data.state == 1){
              this.centerDialogVisible1 = true
              this.handleChangeImg(data)
              this.dowloadImgName = data.name + '案例海报'
              if(data.contentType == 1){
              this.link = this.$config.prUrl + '#/webenterprise/enCaseDetail?id='+ data.id
              }else{
                this.link = data.content
              }
            }else{
              this.$message.error('请先开启状态')
            }
          },
      // 打开预览
      preview(data){
         if(data.contentType == '2'){
                let path=data.content
               window.open(path,'_black')
             }else{
           const newurl = this.$router.resolve({name: 'enCaseDetail', query: {id: data.id,type:1}})
            window.open(newurl.href,'_blank')
             }
      },
      // 状态禁启用
           changeStatus(e){
             if(e.row.state == 0){
           this.$confirm('启用后不得随意删除典型案例内容，请先进行预览，审核后再启用', '开启', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                        }).then(() => {
                        this.editApp(e)
                        }).catch(() => {          
                        });
        }else{
            this.editApp(e)
        }
      },
         editApp(e){
             editCase({
                id:e.row.id,
                state:e.row.state == 1 ? '0' : '1',
                    },'put')
                .then(res => {
                  if(res.code ==1){
                     this.$message.error(res.msg); 
                  }else{
                    e.row.state == 1 ? this.$util.Notifi('已禁用','error','fa-exclamation-circle') : this.$util.Notifi('启用成功','success','fa-check')
                    this.gethisInfo()
                  }
                })
                .catch(err => {
                })
        },
       // 子组件触发
      emitFun(val,val1){
        if(val1 == "PageSize") this.PageSize = val
       if(val1 == "currentPage") this.currentPage = val
       this.gethisInfo()
      },
      // 分类列表
      getcaseClassify(){
         caseClassify({name:'',officialType:''})
         .then(res =>{
          if(res.code == 0){
            this.options = res.data
          }else{
            this.$util.Notifi(res.msg,'error','fa-exclamation-circle');
          }
         })
         .catch(err =>{})
      },
      // 获取典型案例列表
       gethisInfo(){
        let that = this
        if(this.selectType) this.radio = 1
        let params = {
            name:this.search,
            id:this.search1,
            classifyId:this.value,
            state:this.radio,
            createTimeStart:this.start_time,
            createTimeEnd:this.end_time,
            officialType:this.radio1,
            size:this.PageSize,
            current:this.currentPage,
        }
         caseList(params)
          .then(res => {
            this.list = res.data.records
            this.totalCount = res.data.total
             if(this.selectType){
                      let rows = []
                      if(!this.isAppId){
                         for (let m = 0; m < this.selsctarr.length; m++) {
                        for (let n = 0; n < this.list.length; n++) {
                        if (this.selsctarr[m].id === this.list[n].id  || this.selsctarr[m].caseId === this.list[n].id) {
                            
                            rows.push(this.list[n])
                        }
                        }
                    }
                      }else{
                            for (let m = 0; m < this.selsctarr.length; m++) {
                        for (let n = 0; n < this.list.length; n++) {
                        if (this.selsctarr[m].caseId == this.list[n].id || this.selsctarr[m].id === this.list[n].id) {
                            rows.push(this.list[n])
                        }
                        }
                    }
                      }
                       rows.forEach(row => {
                        that.$refs.multipleTable.toggleRowSelection(row,true)
                    })
 
             }
           
          })
          .catch(err => {

          })
       },
       allradio(type){
          this[`radio${type}`] = ""
          this.currentPage = 1
           this.gethisInfo()
        },
        // 重置
        reset(){
          this.search = ""
          this.search1 = ""
          this.radio = ""
          this.radio1 = ""
          this.value = ""
          this.value1 = ""
          this.start_time = ""
          this.end_time = ""
          this.currentPage = 1
           this.gethisInfo()
        },
          // 企业分类筛选
         classSelect(){
            if(this.value1){
             this.start_time = this.value1[0]
            this.end_time = this.value1[1]
            }
            else{
                this.start_time=""
                this.end_time = ""
            }
            this.currentPage = 1
            this.gethisInfo()
        },
        // 新增典型案例
        addSolution(data){
          data.id ? this.$router.push({name:'addCase',query:{id:data.id}}) : this.$router.push("/addCase")
        },
           // 典型案例删除
        deletSolution(data){
          if(data.state == '1') return this.$util.Notifi('您需要先禁用该典型案例后方能删除，请先禁用典型案例','error','fa-exclamation-circle')
         this.$confirm('典型案例删除后将无法展示, 确认删除吗?', '删除', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
            getCase({
              id:data.id,
              },'delete')
                .then(res => {
                 if(res.code == 0){
                  this.$util.Notifi('删除成功','success','fa-check')
                  this.gethisInfo()
                 }else{
                  this.$util.Notifi(res.msg,'error','fa-exclamation-circle')
                 }
              })
              .catch(err => {
              })
        })
        },
    },
}
</script>
<style lang="scss" scoped>
  .businessList-container {
    .businessList-container-title {
      font-size: 18px;
      color: #409eff;
      background-color: rgba(242, 242, 242, 1);
      padding: 10px 20px;
      .mft {
        cursor: pointer;
      }
    }
    .businessList-container-table {
      margin-top: 20px;
      .el-switch {
        position: relative;
        z-index: 1 !important;
      }
      .el-switch.is-disabled {
        opacity: 1 !important;
      }
      .buStatus{
        width: 50px;
        margin: 0 auto;
      }
    }
    .jiange {
      margin-top: 20px;
    }
  }
  ::v-deep {
  .el-switch.is-disabled .el-switch__core {
    cursor: pointer !important;
    width: 50px !important;
  }
        .el-dialog{
      
            .el-dialog__header{
                background: #ccc;
               border-radius: 2px 2px 0 0;
            }
        }
             .dia-can{
        .canvas{
            position:relative !important;
            top: 0 !important;
            display: block;
            margin: 0 auto;
        }
    }
           .dia-btn{
            width: 100px;
        	height: 32px;
				line-height: 30px;
				font-size: 14px;
				padding: 0 16px;
				border-radius: 2px;
				font-family: inherit;
				border-width: 1px;
				border-style: solid;
				text-align: center;
				vertical-align: middle;
				box-sizing: border-box;
				cursor: pointer;
				transition: all .3s;
				background: $base-color-btn;
				color: #fff;
                margin: 20px auto;
                margin-bottom: 0;
    }
}
</style>